
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ExternalLink } from "lucide-react";
import Image from "@/components/ui/image";

interface PmsIntegrationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRmsCloudIntegration: () => void;
  onMewsIntegration: () => void;
  onCloudbedIntegration: () => void;
}

const PmsIntegrationDialog: React.FC<PmsIntegrationDialogProps> = ({
  open,
  onOpenChange,
  onRmsCloudIntegration,
  onMewsIntegration,
  onCloudbedIntegration,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Choose Property Management System</DialogTitle>
          <DialogDescription>
            Select the PMS you want to integrate with
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* RMS Cloud Card */}
            <Card className="cursor-pointer hover:border-primary transition-colors" onClick={onRmsCloudIntegration}>
              <CardHeader className="pb-2">
                <CardTitle className="text-lg">RMS Cloud</CardTitle>
                <CardDescription>
                  Connect to RMS Cloud property management
                </CardDescription>
              </CardHeader>
              <CardContent className="flex justify-center pt-2">
                <img 
                  src="/lovable-uploads/58312362-8e60-458a-a45a-b76123a15390.png" 
                  alt="RMS Cloud logo" 
                  className="h-14 object-contain"
                />
              </CardContent>
              <CardFooter className="pt-0">
                <Button variant="outline" size="sm" className="w-full">
                  Connect <ExternalLink className="ml-2 h-3 w-3" />
                </Button>
              </CardFooter>
            </Card>

            {/* MEWS Card */}
            <Card className="cursor-pointer hover:border-primary transition-colors" onClick={onMewsIntegration}>
              <CardHeader className="pb-2">
                <CardTitle className="text-lg">MEWS</CardTitle>
                <CardDescription>
                  Connect to MEWS property management
                </CardDescription>
              </CardHeader>
              <CardContent className="flex justify-center pt-2">
                <img 
                  src="/lovable-uploads/24e3fae8-5b39-4c6c-81fc-c8e39a63fda0.png" 
                  alt="MEWS logo" 
                  className="h-14 object-contain" 
                />
              </CardContent>
              <CardFooter className="pt-0">
                <Button variant="outline" size="sm" className="w-full">
                  Connect <ExternalLink className="ml-2 h-3 w-3" />
                </Button>
              </CardFooter>
            </Card>

            {/* Cloudbeds Card */}
            <Card className="col-span-1 md:col-span-2 cursor-pointer hover:border-primary transition-colors" onClick={onCloudbedIntegration}>
              <CardHeader className="pb-2">
                <CardTitle className="text-lg">Cloudbeds</CardTitle>
                <CardDescription>
                  Connect to Cloudbeds property management
                </CardDescription>
              </CardHeader>
              <CardContent className="flex justify-center pt-2">
                <img 
                  src="/lovable-uploads/1b545172-67ee-42c5-a7ae-6b13b9cafe3e.png" 
                  alt="Cloudbeds logo" 
                  className="h-12 object-contain" 
                />
              </CardContent>
              <CardFooter className="pt-0">
                <Button variant="outline" size="sm" className="w-full">
                  Connect <ExternalLink className="ml-2 h-3 w-3" />
                </Button>
              </CardFooter>
            </Card>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PmsIntegrationDialog;
